define([
    '../Util/Check',
    '../Util/defaultValue',
    '../Util/defined',
    '../System/ColorObj'
], function (
    Check,
    defaultValue,
    defined,
    ColorObj) {
    'use strict'

    /**
     * 圆圈对象。
     * @param {Number} radius 圆圈半径。
     * @param {ColorObj|String} color 圆圈颜色，支持ColorObj对象或十六进制字符串（如"#FF0000"）。
     * @param {String} text 圆圈文字。
     * @param {ColorObj|String} textColor 圆圈文字颜色，支持ColorObj对象或十六进制字符串（如"#FF0000"）。
     * 
     * @alias CircleObj
     * @constructor
     *
     */
    class CircleObj {
        /**
         * @description 在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "CircleObj"
        /**
         * @description 圆圈半径。
         * @type {Number}
         */
        radius
        /**
         * @description 圆圈颜色，支持ColorObj对象或十六进制字符串（如"#FF0000"）。
         * @type {ColorObj|String}
         */
        color
        /**
         * @description 圆圈文字。
         * @type {String}
         */
        text
        /**
         * @description 圆圈文字颜色，支持ColorObj对象或十六进制字符串（如"#FF0000"）。
         * @type {ColorObj|String}
         */
        textColor

        constructor(radius, color, text, textColor) {
            this.radius = defaultValue(radius, 100.0)
            // 处理color参数，支持ColorObj或十六进制字符串
            if (typeof color === 'string') {
                this.color = this._hexToColorObj(color);
            } else {
                this.color = defaultValue(color, new ColorObj(0, 0, 0, 1));
            }
            this.text = defaultValue(text, "")
            if (typeof textColor === 'string') {
                this.textColor = this._hexToColorObj(textColor);
            } else {
                this.textColor = defaultValue(textColor, new ColorObj(0, 0, 0, 1));
            }
        }

        /**
         * @private
         * @description 将十六进制颜色转换为ColorObj对象
         * @param {String} hexColor 十六进制颜色值，如"#FF0000"
         * @returns {ColorObj} 转换后的颜色对象
         */
        _hexToColorObj(hexColor) {
            // 移除#前缀
            hexColor = hexColor.replace(/^#/, '');
            
            let r, g, b, a = 1;
            
            // 处理3位颜色值 #RGB
            if (hexColor.length === 3) {
                r = parseInt(hexColor[0] + hexColor[0], 16) / 255;
                g = parseInt(hexColor[1] + hexColor[1], 16) / 255;
                b = parseInt(hexColor[2] + hexColor[2], 16) / 255;
            } 
            // 处理4位颜色值 #RGBA
            else if (hexColor.length === 4) {
                r = parseInt(hexColor[0] + hexColor[0], 16) / 255;
                g = parseInt(hexColor[1] + hexColor[1], 16) / 255;
                b = parseInt(hexColor[2] + hexColor[2], 16) / 255;
                a = parseInt(hexColor[3] + hexColor[3], 16) / 255;
            }
            // 处理6位颜色值 #RRGGBB
            else if (hexColor.length === 6) {
                r = parseInt(hexColor.slice(0, 2), 16) / 255;
                g = parseInt(hexColor.slice(2, 4), 16) / 255;
                b = parseInt(hexColor.slice(4, 6), 16) / 255;
            }
            // 处理8位颜色值 #RRGGBBAA
            else if (hexColor.length === 8) {
                r = parseInt(hexColor.slice(0, 2), 16) / 255;
                g = parseInt(hexColor.slice(2, 4), 16) / 255;
                b = parseInt(hexColor.slice(4, 6), 16) / 255;
                a = parseInt(hexColor.slice(6, 8), 16) / 255;
            } else {
                // 默认为黑色
                r = g = b = 0;
            }
            
            return new ColorObj(r, g, b, a);
        }
    }
    return CircleObj
})